import Banner from '@/components/Banner2';
import { FEATURES_LIST, SKILL_LIST } from './index.js';
import Title from '@/components/Title/index.vue';
import Advantages from '@/components/Advantages2/index.vue';
import AdcantageFeatures from '@/components/FunctionCard2/index.vue';
import Securities from './components/Securities.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Title,
    Advantages,
    AdcantageFeatures,
    Securities,
    Appointment2
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      skillList: SKILL_LIST,
      productId: this.$productId.PC_KE_HU_DUAN.PC_YUAN_HANG_BAN,
      // advantages
      leftItems: [{
        title: '开发及兼容性好',
        desc: '远航版基于微软的 .NET 平台，在保持高效开发的同时，对旧的Win32平台提供了完美兼容性'
      }, {
        title: '支持自主开发更新',
        desc: '行业领先的语音识别、语义理解、知识图谱构建、用户画像定义、大数据挖掘分析处理等技术，带来更专业的智能服务。'
      }],
      rightItems: [{
        title: '全新的UI框架',
        desc: '支持多语言、多字体、多皮肤、多主题、多DPI适配及高分屏'
      }, {
        title: '定制性更丰富',
        desc: '用户可基于Python脚本定制功能、逻辑；开放的协议接入方便客户提供数据进行展示'
      }],
      img: require('@/assets/images/service/sailing-version/sailing-version-advantage-icon.png'),
      // 产品特色
      adcantageFeaturesList: [{
        name: '自定义表头项',
        desc: '“自定义表头项”功能可通过自然语言搜索形成个性化表头项，让每一位投资者在享受定制化服务的同时，高效选出心仪的股票'
      }, {
        name: '策略板块',
        desc: '“策略板块”功能使用自然语言形成热门策略及自定义策略，兼顾市场热点及个人投资偏好，帮助投资者缩小选股范围，实现快捷选股'
      }, {
        name: '星空图',
        desc: '该功能以可视化的形式展示多维数据，帮助投资者在短时间内清晰定位个股属性、统筹把握板块全局，真正做到“既观森林，又见树木”'
      }, {
        name: 'Python指标编辑',
        desc: '支持python指标编辑，进一步实现了更广泛的指标定制化需求'
      }, {
        name: '涨停基因',
        desc: '“涨停基因”功能通过统计个股近一年来触及涨停的情况，联动K线研判股性，有效帮助投资者把握跟风套利的机会'
      }, {
        name: '特色盘口',
        desc: '盘口功能可以及时向投资者解释股票涨、跌停原因，助力投资者精准把握当天市场行情，为其次日的操作保驾护航'
      }, {
        name: '热点盯盘',
        desc: '热点盯盘能够及时监测、反馈市场热点异动，确保投资者不错过每一个投资风口'
      }, {
        name: '事件驱动',
        desc: '盘口功能可以及时向投资者解释股票涨、跌停原因，助力投资者精准把握当天市场行情，为其次日的操作保驾护航'
      }],
      imgSrc: require('@/assets/images/service/sailing-version/sailing-version-advantegefeature.png')
    };
  }
};